module.exports = {"logoAlt":"Jheng-Hao Lin","title":"Web Development | React Enthusiast | Computer Science"}


//////////////////
// WEBPACK FOOTER
// ./src/contents/home.json
// module id = 41
// module chunks = 0